module.exports = __webpack_public_path__ + "img/left_arrow_white.71b41bb1.svg";